import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChefHat } from "lucide-react";
export function ChefBettyAvatar({ size = 'md', withLabel = false }) {
    const sizeClasses = {
        sm: 'w-8 h-8',
        md: 'w-10 h-10',
        lg: 'w-16 h-16'
    };
    const iconSizes = {
        sm: 'w-4 h-4',
        md: 'w-5 h-5',
        lg: 'w-8 h-8'
    };
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: `${sizeClasses[size]} rounded-full bg-primary flex items-center justify-center shadow-vintage-sm border-2 border-primary`, children: _jsx(ChefHat, { className: `${iconSizes[size]} text-primary-foreground` }) }), withLabel && (_jsxs("div", { children: [_jsx("p", { className: "text-sm text-foreground", style: { fontFamily: 'var(--font-display)' }, children: "Chef Betty" }), _jsx("p", { className: "text-xs text-muted-foreground", children: "Kitchen Helper" })] }))] }));
}
